import React, { useEffect, useState } from "react";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Label,Input,Modal,ModalHeader,Button } from "reactstrap";
import Table from 'react-bootstrap/Table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';



export default function Disputes() {
    const[email,setEmail] = useState('');
    const[company,setCompany]=useState('');
    const[disputes, setDisputes] = useState([]);
    const[search, setSearch] = useState('');
    const[modal, setModal] = useState(false);
    const [tab, setTab] = useState(1);
    const [selectedOrder, setSelectedorder] = useState('');
    const [orderNumber, setOrdernumer] = useState('');
    const [customerName, setCustomername] = useState('');
    const [customerPhone, setCustomerphone] = useState('');
    const [storename, setStorename] = useState('');
    const [orderValue, setOrdervalue] = useState('');
    const [deliveryLocation, setDeliverylocation] = useState('');
    const [landmark, setLandmark] = useState('');
    const [deliveryType, setDeliverytype] = useState('');
    const [instructions, setInstructions] = useState('');
    const [createdAt, setCreatedAt] = useState('');
    const [allocatedAt,setAllocatedat] = useState('')
    const [dispatechedAt, setDispatchedat] = useState('');
    const [deliveredAt, setDeliveredat] = useState('');
    const [cancelledAt, setCancelledat] = useState('');
    const [status, setStatus] = useState('');
    const [distance, setDistance] = useState('');
    const [amount, setAmount] = useState('');
    const [rider, setRider] = useState('');
    const [orderItems, setOrderitems] = useState([]);

    const tab1=()=>{
        setTab(1)
    }
    const tab2=()=>{
        setTab(2)
    }
    const tab3=()=>{
        setTab(3)
    }

    const toggle=async(e)=>{
        const id = e.target.value;
        setSelectedorder(id);
        const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getThisordernumber?id=${id}`);
        const data = await res.json();
        setCustomername(data.customerName);
        setOrdernumer(data.orderNumber);
        setCustomerphone(data.customerPhone);
        setOrdervalue(data.orderValue);
        setStorename(data.store_name);
        setDeliverylocation(data.deliveryLocation);
        setLandmark(data.landmark);
        setDeliverytype(data.deliveryType);
        setInstructions(data.instructions);
        setCreatedAt(data.createdAt);
        setAllocatedat(data.allocatedAt);
        setDispatchedat(data.dispatchedAt);
        setDeliveredat(data.deliveredAt);
        setCancelledat(data.cancelledAt);
        setStatus(data.status);
        setDistance(data.distance);
        setAmount(data.amount);
        setRider(data.ridername);

        setModal(!modal);

    }

    
        useEffect(()=>{
            const getItems =async()=>{
                const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getOrderitems?orderNumber=${orderNumber}`);
                const data = await res.json();
                setOrderitems(data);
            }
            
            if(orderNumber){
                getItems();
            }
    
        },[orderNumber])

    useEffect(() => {
        const fetchProfile = async () => {
          try {
            const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/profile', {
              credentials: 'include', // to send cookies
            });
            const data = await res.json();
    
            if (data.valid) {
              setEmail(data.email)
            } else {}
          } catch (error) {} 
        };
    
        fetchProfile();
      }, []);
    
      //get store id
      useEffect(()=>{
       const fetchData = async()=>{
          try{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
            const data = await res.json();
            setCompany(data.company)
          }
          catch(err){}
       }
    
       if(email){
        fetchData();
       }
       
      },[email])

      useEffect(()=>{
        const getDisputes =async()=>{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getDisputes?company=${company}`);
            const data = await res.json();
            setDisputes(data)
        }

        if(company){
            getDisputes();
        }

      },[company])

          useEffect(()=>{
              const searchOrder = async()=>{
                  const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/searchDispute?search=${search}&company=${company}`);
                  const data = await res.json();
                  setDisputes(data);
      
                  
              }
      
              if(search){
                      searchOrder()
                  }
      
          },[search])
          

      const exportToPdf = () => {
        const doc = new jsPDF();
    
        // Add a title to the PDF
        doc.text("Easybox_disputes", 20, 10);
    
        // Extract table headers and rows from the DOM
        const table = document.getElementById("dataTable");
        const headers = Array.from(
          table.querySelectorAll("thead tr th")
        ).map((header) => header.textContent);
    
        const rows = Array.from(table.querySelectorAll("tbody tr")).map((row) =>
          Array.from(row.querySelectorAll("td")).map((cell) => cell.textContent)
        );
    
        // Generate the PDF table
        doc.autoTable({
          head: [headers],
          body: rows,
          startY: 20,
        });
    
        // Save the PDF
        doc.save("Easybox_disputes.pdf");
      };



  return (
    <div className="pagesContainer">
         <Breadcrumbs title="Easybox" breadcrumbItem="Disputes" />
        <div className="card" style={{padding:'10px'}}>
        <div className="searchBar">
            <div className="mb-4" id="mb">
                <Label className="form-label">Search order</Label>
                <Input
                    name="search"
                    className="form-control"
                    placeholder="Search order"
                    type="text"
                    onChange={(e)=>{setSearch(e.target.value)}}
                    value={search}

                />
                
            </div>

        </div>
        <div className="">
        <Button color='success' onClick={exportToPdf}>Export</Button>
        </div>
        <hr />
        
        <div className="table-responsive">
        <Table striped bordered hover id="dataTable">

            <thead>
                <tr>
                    
                    <th scope="col">#</th>
                    <th scope="col">Order Number</th>
                    <th scope="col">Status</th>
                    <th scope="col">Reason</th>
                    <th scope="col">Created at</th>                    
                </tr>
            </thead>
            <tbody>
            {disputes.map((val,index)=>{
                const postDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.createdAt)
                const postTime =  new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(val.createdAt)

                return(
                    <tr>
                        <td>{index+1}</td>
                        <td><button className="tableButton" value={val.orderNumber} onClick={toggle}>{val.orderNumber}</button></td>
                        <td>{val.status}</td>
                        <td>{val.reason}</td>
                        <td>{postDate},{postTime}</td>
                    </tr>
                )
            })}
            </tbody>
            </Table>
        </div>
    </div>


    <Modal isOpen={modal} toggle={toggle} size='lg'>
                <ModalHeader>Order #{orderNumber} - {status}</ModalHeader>
                <div className="modalContainer">
                    <div className="modalBar">
                        <button onClick={tab1} className='topButton'>Basic information</button>
                        <button onClick={tab2} className='topButton'>Customer information</button>
                        <button onClick={tab3} className='topButton'>Delivery information</button>
                    </div>
                    {tab == 1 &&
                    <>
                        <hr />
                        <h5>Basic information</h5>
    
                        <p><strong>Store: </strong>{storename}</p>
                        <p><strong>Value: </strong>Kes. {orderValue}</p>
                        <p><strong>Items: </strong></p>
                        {orderItems.map((val,index)=>{
                            return(
                                <p>{index+1}. {val.item} - {val.quantity} </p>
                            )
                        })}
                        {orderItems.length == 0 &&
                        <p>No items available</p>
                        
                        }
                        {status == 'Pending' &&
                            <>
                            <p><strong>Created : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(createdAt)}</p>
                            
                            </>
                        }
                        {status == 'Dispatch' &&
                        <>
                            <p><strong>Created : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(createdAt)}</p>
                            <p><strong>Allocation time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(allocatedAt)}</p>
                            
                           
                            
                            
                        </>
                        }
                        {status == 'Transit' &&
                        <>
                            <p><strong>Created : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(createdAt)}</p>
                            <p><strong>Allocation time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(allocatedAt)}</p>
                            <p><strong>Dispatch time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(dispatechedAt)}</p>
                           
                        </>
                        }
                        {status == 'Delivered' &&
                        <>
                            <p><strong>Created : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(createdAt)}</p>
                            <p><strong>Allocation time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(allocatedAt)}</p>
                            <p><strong>Dispatch time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(dispatechedAt)}</p>
                            <p><strong>Delivery time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(deliveredAt)}</p>
                        </>
                        }
                        {status == 'Cancelled' &&
                        <>
                            <p><strong>Created : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(createdAt)}</p>
                            <p><strong>Allocation time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(allocatedAt)}</p>
                            <p><strong>Dispatch time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(dispatechedAt)}</p>
                            <p><strong>Cancelation time : </strong>{new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(createdAt)},{new Intl.DateTimeFormat('en-US',{hour:'2-digit',minute:'2-digit', second:'numeric'}).format(cancelledAt)}</p>
                        </>
                        }
    
                        
                       
                      
                        
    
    
                    </>
                    }
    
                    {tab == 2 &&
                    <>
                        <hr />
                        <h5>Customer information</h5>
                        <p><strong>Name: </strong>{customerName}</p>
                        <p><strong>Phone: </strong>{customerPhone}</p>
                        <p><strong>Instructions: </strong>{instructions}</p>
                    </>
                    }
    
                    {tab == 3 &&
                    <>  <hr />
                        <h5>Delivery information</h5>
                        <p><strong>Delivery location: </strong>{deliveryLocation}</p>
                        <p><strong>Nearest Landmark: </strong>{landmark}</p>
                        <p><strong>Distance: </strong>{distance} KM</p>
                        <p><strong>Rider: </strong>{rider}</p>
                    </>
                    }
                    
                            
                    <p style={{textAlign:'right',color:'red',cursor:'pointer'}} onClick={()=>setModal(false)}>Close</p>
                </div>
            </Modal>
    </div>
  )
}
